import { Tab } from "@mui/material";
import { STab, STabProps } from "components/parts";
import { labels } from "messages/labels";
import { useController, useFormContext } from "react-hook-form";

type Props = STabProps &
  Partial<{
    handleOk: Function;
  }>;

export const SEntryTab = (props: Props) => {
  const methods = useFormContext();
  const { field } = useController({
    name: props.name,
    control: methods.control,
  });

  const handleClick = () => {
    methods.setValue(props.name, true);
    if (props.handleOk) props.handleOk();
  };

  return (
    <>
      <STab
        {...props}
        {...field}
        value={methods.watch(props.name) ? 0 : 1}
        onChange={(event, value) => {
          methods.setValue(props.name, value === 0);
          props.onChange?.call(this, event, value);
        }}
      >
        <Tab label={labels.tabs.new} value={0} onClick={handleClick} />
        <Tab
          label={labels.tabs.edit}
          value={1}
          disabled={methods.watch(props.name)}
        />
      </STab>
    </>
  );
};
